module.exports = {
  title: 'Balloons Slider Animation with React Native 🎈',
  author: 'Enzo Manuel Mangano',
  date: '2023-02-22',
  slug: 'cuberto-slider',
  tags: ['reanimated', 'gesture-handler'],
};
